import React, { useState } from "react";
import { Button } from "@mui/material";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import DrawerAppBar from "../../../../../components/mobile/Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useErrorHandler } from "../../../../hooks";
import { Total } from "../../../Components/Total";
import { useAuditContext } from "../../store";
import {
  AuditPosition,
  ItemCount,
} from "../../../../../../domain/usecases/audit-position";

type Props = {
  auditPosition: AuditPosition;
};

export const AuditList: React.FC<Props> = ({ auditPosition }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { position, list, setResult, setList, setPosition } = useAuditContext();

  const handleError = useErrorHandler((error) => {
    alert(error);
  });

  async function check() {
    try {
      if (!position || !list)
        return navigate("/mobile/audit/position-collector");
      const res = await auditPosition.audit({
        positionId: position.id!,
        count: list.map((item) => ({
          ...item,
          amount: Number((item.amount * (item?.packageAmount || 1)).toFixed(2)),
        })) as ItemCount,
      });
      if (res.status === "completed") {
        alert("Contagem bem sucedida!");
        setList(null);
        setPosition(null);
        navigate("/mobile/tasks");
      }
      setResult(res);
      navigate("/mobile/audit/report");
    } catch (error) {
      handleError(error as Error);
    }
  }

  return (
    <>
      <DrawerAppBar
        title="Lista de Contagem"
        onBack={() => {
          navigate(-1);
        }}
      />
      <Total text="Total de Itens Contados" number={`${list?.length || 0}`} />
      <Stack sx={{ m: "20px" }} spacing={4}>
        {list?.map((item, index) => {
          return (
            <Paper sx={{ padding: "20px" }} key={index}>
              <Stack spacing={2}>
                <Typography fontWeight="bold" fontSize="24px">
                  {item.description}
                </Typography>
                <Typography>{`Fornecedor: ${item.supplier}`}</Typography>
                {item.batchControl && (
                  <Typography>{`Lote: ${item.batch}`}</Typography>
                )}
                <Typography>{`Quantidade: ${item.amount}`}</Typography>
              </Stack>
            </Paper>
          );
        })}

        <Button
          variant="contained"
          color="secondary"
          sx={{ color: "white", height: "50px", fontWeight: "bold" }}
          onClick={check}
        >
          {isLoading ? <CircularProgress /> : "Finalizar Conferência"}
        </Button>
      </Stack>
    </>
  );
};
